import { useSelector, useDispatch } from 'react-redux';
import { setToken, setUser as setUserAction } from '../redux/slices/auth.slice';
import { getSocket } from '../socket';

const useCurrentUser = () => {
    const dispatch = useDispatch();
    const { user, loading, token, error } = useSelector((state) => state.auth);

    const setUser = (userData) => {
        dispatch(setUserAction(userData));
    };

    const handleSetToken = (newToken) => {
        dispatch(setToken(newToken));
    };

    return {
        user,
        setUser,
        loading,
        token,
        setToken: handleSetToken,
        socket: getSocket(),
        error
    };
};

export default useCurrentUser;